module.exports = __webpack_public_path__ + "static/media/zapsplat_household_antique_larder_door_creak_001_19470.0ec0228a.wav";